import { BaseHelper } from './BaseGraphQLAPIHelper';

export const getStores = () => {
  const query = `{
        stores(first: 100) {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              pk
              name
              photo
              photo2
              photo3
              address
            }
          }
        }
      }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getStoresOfBrand = (brandID, afterCursor) => {
  const query = `{
    brand(id: "${brandID}", after: "${afterCursor}") {
      stores(first: 20) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            id
            pk
            name
            photo
            photo2
            photo3
            address
            translations {
              edges {
                node {
                  language
                  name
                }
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getPagedStores = (afterCursor, search = {}) => {
  // const order = rank ? '-pk' : 'pk';

  let searchString = '';
  if (search.search) {
    searchString += `, name: "${search.search}"`;
  }
  if (search.subcategory) {
    searchString += `, subcategoriesIn: "${search.subcategory}"`;
  }
  let orderBy = 'displayPriority';
  if (search?.sort) {
    orderBy = search.sort;
  }
  if (search?.brands) {
    searchString += `, brandIn: "${search.brands}"`;
  }

  if (search?.isAllRecyling) {
    searchString += `, isAllRecyling: "${search.isAllRecyling}"`;
  }
  if ((search || {})['reverse_vending_machine']) {
    searchString += `, isReverseVendingMachine: ${
      search['reverse_vending_machine'] === 'Yes' ? 'true' : 'false'
    }`;
  }

  const query = `{
    stores(first: 20, after: "${afterCursor}", orderBy: "${orderBy}"${searchString}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          name
          displayPriority
          photo
          photo2
          photo3
          address
          phoneNumberCountryCode
          phoneNumberSubscriberNumber
          latitude
          longitude
          emailAddress
          description
          staffCode
          subcategories(first: 50) {
              edges {
                  node {
                      pk
                      category {
                          pk
                          name
                          displayPriority
                      }
                      name
                      displayPriority
                  }
              }
          }
          isAvailable
          isPublic
          hideInMap
          isReverseVendingMachine
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getOneStore = (id) => {
  const query = `{
    store(id: "${id}") {
      id
      pk
      name
      displayPriority
      photo
      photo2
      photo3
      address
      phoneNumberCountryCode
      phoneNumberSubscriberNumber
      latitude
      longitude
      emailAddress
      description
      staffCode
      subcategories(first: 100) {
          edges {
              node {
                  pk
                  id
                  category {
                      name
                      pk
                  }
                  name
              }
          }
      }
      district {
          region {
              pk
              name
          }
          name
          pk
      }
      brand {
          pk
          name
      }
      translations {
          edges {
          node {
              pk
              language
              name
              description
              address
          }
          }
      }
      isAvailable
      isPublic
      hideInMap
      isReverseVendingMachine
      securityKey
    }
  }
  `;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteStores = (ids) => {
  const query = `mutation DeleteStores($input: DeleteStoresInput!) {
    deleteStores(input: $input) {
      success
    }
  }
  `;
  const variables = { input: { ids: ids } };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createOrUpdateStore = (values) => {
  const action = values.id ? 'Update' : 'Create';
  let query = `mutation ${action}Store($input: ${action}StoreInput!) {
    ${action.toLowerCase()}Store(input: $input) {
      success
      node {
          id
          pk
          name
      }
      errors {
        field
        messages
      }
    }
  }

  `;

  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getDistricts = () => {
  const query = `{
    districts(first: 50, orderBy: "pk") {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          region {
              pk
              name
          }
          name
          translations {
            edges {
              node {
                language
                name
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};
